import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { OrderStatus } from "../../interfaces/EOrderStatus";
import { OnboardingSources } from "../signup/types";
export enum OrderTypes {
  COLLECTION = "COLLECTION",
  TABLE_DELIVERY = "TABLE_DELIVERY",
  HOME_DELIVERY = "HOME_DELIVERY",
  PICKUP_NOW = "COLLECTION_POINT_PICKUP",
}
export const SearchItems = [
  {
    key: "order_hash_id",
    value: "orderHistory.search.orderId",
  },
  {
    key: "order_table_number",
    value: "orderHistory.search.tableNumber",
  },
  {
    key: "customer_email",
    value: "orderHistory.search.emailAddress",
  },
  {
    key: "customer_phone",
    value: "orderHistory.search.contactNumber",
  },
];

export const FilterItemsInitialState = {
  COLLECTION: false,
  TABLE_DELIVERY: false,
  HOME_DELIVERY: false,
};

export interface IProcessedOrders {
  [key: string]: string;
  consumer_id: string;
  created_on: string;
  created_on_time: string;
  created_on_date: string;
  id: string;
  order_status: string;
  order_total: string;
  order_type: string;
  venue_id: string;
  hash_id: string;
  table_id: string;
  collection_point_id: string;
}

export interface IAddress {
  full_name: string;
  postcode: string;
  address: string;
  street_address: string;
  apartment: string;
  city: string;
}

export interface IProcessedOrdersDetails {
  consumer: {
    consumer_contact_phone?: string;
    consumer_first_name: string;
    consumer_last_name: string;
    consumer_contact_preference: string;
    consumer_id: string;
    consumer_contact_email?: string;
  };
  in_order: IOrderItem[];
  placed_order: IPlacedOrder;
}

export const baseStateStyling: CSSProperties = {
  backgroundColor: "#EEF0F6",
  borderRadius: 10,
  borderStyle: "none",
  padding: 5,
  boxSizing: "border-box",
  fontSize: "0.9375rem!important",
  lineHeight: "1.25rem",
  color: "#424242",
};
export const stateStylings: { [key: string]: CSSProperties } = {
  FINISHED: {
    ...baseStateStyling,
    backgroundColor: "#c8c3fa",
    color: "#874dfa",
  },
  CLOSED: {
    ...baseStateStyling,
    backgroundColor: "#c8c3fa",
    color: "#874dfa",
  },
  PLACED: {
    ...baseStateStyling,
    backgroundColor: "#d7dbfc",
    color: "#598eeb",
  },
  FUNDS_RECEIVED: {
    ...baseStateStyling,
    backgroundColor: "#d7dbfc",
    color: "#598eeb",
  },
  REFUNDED: {
    ...baseStateStyling,
    backgroundColor: "#d7dbfc",
    color: "#598eeb",
  },
  ACCEPTED: {
    ...baseStateStyling,
    backgroundColor: "#edfcf2",
    color: "#56db82",
  },
  STARTED: {
    ...baseStateStyling,
    backgroundColor: "#bad4e8",
    color: "#46a6f0",
  },
  VOID: {
    ...baseStateStyling,
    backgroundColor: "#ff9d9d",
    color: "#ec2525",
  },
  DECLINED: {
    ...baseStateStyling,
    backgroundColor: "#e8baba",
    color: "#f21136",
  },
  REJECTED: {
    ...baseStateStyling,
    backgroundColor: "#e3e3e3",
    color: "grey",
  },
  PARTIALLY_REFUNDED: {
    ...baseStateStyling,
    backgroundColor: "#FEEEE0",
    color: "#FA7800",
  },
  DEFAULT: baseStateStyling,
  READY_FOR_COLLECTION: {
    ...baseStateStyling,
    backgroundColor: "#DDEEFE",
    color: "#1D8BF7",
  },
};

export interface IOrderItem {
  in_order_group_discount_price: number;
  in_order_group_quantity: number;
  in_order_group_quantity_refunded: number;
  in_order_group_selling_price: number;
  in_order_id: string;
  in_order_item_discount_price: number;
  in_order_item_preferences?: string[];
  in_order_item_selling_price: number;
  in_order_sold_as_extra: boolean;
  in_order_pricing_option_key: string;
  in_order_pricing_option_name: string;
  in_order_is_refunded: boolean;
  in_order_sold_with_in_order_item_id: string;
  menu_item_description: string;
  menu_item_name_public: string;
  menu_item_id: string;
  in_order_item_discount_code_amount: number;
  in_order_item_discount_code_percentage: number;
  in_order_item_discount_code_price: number;
  in_order_item_discount_amount: number;
  in_order_item_discount_percentage: number;
  in_order_item_vat_amount: number;
  menu_name_public?: string;
  menu_name_private?: string;
}
export type filtersObject = Record<string, boolean>;

export interface IOrderItemParent {
  main: IOrderItem | {};
  extras: IOrderItem[];
}

export interface IPlacedOrder {
  placed_order_comment: string;
  placed_order_customer_note: string;
  placed_order_created_on: string;
  placed_order_delivery_address: IAddress;
  placed_order_delivery_table: string;
  placed_order_est_delivery_time: string;
  placed_order_id: string;
  placed_order_order_gratuity: number;
  placed_order_order_processing_charge: number;
  placed_order_order_service_charge: number;
  placed_order_order_status: OrderStatus;
  placed_order_order_total: number;
  placed_order_yoello_processing_total_amount: number;
  placed_order_order_type: OrderTypes;
  placed_order_sum_group_discount_price: string;
  placed_order_sum_group_selling_price: string;
  placed_order_table_area: string;
  placed_order_table_id: string;
  placed_order_takeaway_timeslot: string;
  placed_order_hash_id: string;
  placed_order_updated_on: string;
  currency_id: string;
  currency_iso: string;
  currency_symbol: string;
  placed_order_discount_frozen: string;
  placed_order_discount_code: string;
  placed_order_discount_value: number;
  placed_order_sum_group_discount_code_price: string;
  placed_order_sum_group_vat_amount: number;
  placed_order_order_total_vat_amount: number;
  placed_order_collection_point_id: string;
  placed_order_integration_payment_object_id: string;
  tax_refund_amount: number;
  total_refund_amount: number;
  tax_inclusion_type: TaxType;
  placed_order_payment_method: string;
  placed_order_order_option: OrderOptions;
  placed_order_ext_promotion_price: null | number;
  placed_order_asap_delivery_requested: boolean;
  placed_order_delivery_distance?: number;
  placed_order_distance_unit?: "KILOMETER" | "MILE"
}

export enum DialogOrderTypes {
  NEW_ORDERS,
  OPEN_ORDERS,
  ORDER_HISTORY,
}
export enum TaxType {
  INCLUSIVE = "INCLUSIVE",
  ADDITIVE = "ADDITIVE",
}
export enum PreferredContact {
  Email = "email",
  Sms = "sms",
}
export enum OrderOptions {
  ORDER_ONLY = "ORDER_ONLY",
  ORDER_AND_PAY = "ORDER_AND_PAY",
}

export const IntegrationsList = [
  OnboardingSources.deliverect,
  OnboardingSources.ncr,
  OnboardingSources.oracle,
  OnboardingSources.zonal,
  OnboardingSources.tevalis,
];
